import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { TerminalIndexResponse } from '@/repositories/generated';

const content: TerminalIndexResponse[] = [
  {
    externalTerminalId: 'terminal10021',
    id: '0000000001001',
    terminalType: 'PAPER_QR',
    status: 'AVAILABLE',
    defaultTerminal: true,
    shopName: 'テスト店舗',
    companyName: 'テスト企業',
    startDate: '2023-01-08',
    endDate: '2030-12-31',
    createdAt: '2023-01-23T00:00:00+09:00',
  },
  {
    externalTerminalId: 'terminal10021',
    id: '0000000001001',
    terminalType: 'MERCHANT',
    status: 'WAITING',
    defaultTerminal: true,
    shopName: 'テスト店舗',
    companyName: 'テスト企業',
    startDate: '2025-01-08',
    endDate: '2030-12-31',
    createdAt: '2023-01-23T00:00:00+09:00',
  },
  {
    externalTerminalId: 'terminal10021',
    id: '0000000001001',
    terminalType: 'PAYMENT_TERMINAL',
    status: 'CLOSED',
    defaultTerminal: false,
    shopName: 'テスト店舗',
    companyName: 'テスト企業',
    startDate: '2023-01-08',
    endDate: '2030-12-31',
    createdAt: '2023-01-23T00:00:00+09:00',
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const terminal = http.get(
  createMockEndpoint('/terminal'),
  async ({ request }) => {
    const url = new URL(request.url);
    await delay(500);
    const terminalExists = url.searchParams.get('terminalIds') ?? '';
    const externalExists = url.searchParams.get('externalTerminalIds') ?? '';
    const companyExists = url.searchParams.get('companyIds') ?? '';
    const shopExists = url.searchParams.get('shopIds') ?? '';

    if (terminalExists || externalExists || companyExists || shopExists) {
      return HttpResponse.json({
        content: loopContent.slice(3, 25),
        pageable: {
          sort: {
            empty: true,
            sorted: false,
            unsorted: true,
          },
          offset: 0,
          pageNumber: 0,
          pageSize: 20,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 20,
        size: 20,
        number: 0,
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        first: true,
        numberOfElements: 20,
        empty: false,
      }, { status: 200 });
    }
    // クエリパラメータなし
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);
